import React from 'react';

/**
 * One date field for the whole app (Phase 1 #9).
 *
 * A native <input type="date"> renders in the BROWSER's locale, which showed
 * "19 Oct 2026" to an Icelandic contractor. This field shows and accepts
 * dd.mm.yyyy and keeps the ISO value underneath. The small transparent date
 * input on the right still opens the native picker on a phone.
 */
export const isoToIS = (iso) => {
  const s = String(iso || '').slice(0, 10);
  const [y, m, d] = s.split('-');
  if (!y || !m || !d) return '';
  return `${d}.${m}.${y}`;
};

export const isToIso = (text) => {
  const m = String(text || '').trim().match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/);
  if (!m) return null;
  const [, d, mo, y] = m;
  return `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
};

export const DateFieldIS = ({ label, value, onChange, testId, className = 'input' }) => {
  const [text, setText] = React.useState(isoToIS(value));
  React.useEffect(() => { setText(isoToIS(value)); }, [value]);
  const commit = (raw) => {
    setText(raw);
    const iso = isToIso(raw);
    if (iso) onChange(iso);
    else if (!raw.trim()) onChange('');
  };
  return (
    <div>
      {label && <label className="text-[10px] uppercase text-foreground-muted">{label}</label>}
      <div className="relative">
        <input
          className={`${className} pr-9`}
          inputMode="numeric"
          placeholder="dd.mm.áááá"
          value={text}
          onChange={(e) => commit(e.target.value)}
          data-testid={testId}
        />
        <input
          type="date"
          className="absolute right-0 top-0 h-full w-9 opacity-0 cursor-pointer"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label || 'dagsetning'}
          data-testid={testId ? `${testId}-picker` : undefined}
        />
      </div>
    </div>
  );
};

export default DateFieldIS;
